import TempCache from '../enums/TempCache';
import hideElement from './hideElement';
import TempStorageCache from './TempStorageCache';
import languageTransferListTemplate from '../../templates/dialog/language_transfer_list_template.ejs';
import GlobalVariables from '../GlobalVariables';
import languageTransferRequest from './languageTransferRequest';
import getStorageAPIValue from './getStorageAPIValue';
import getCookieValue from './getCookieValue';

export function getNonSMSAndScriptLanguages(language) {
    const name = language.languageFullName.toLowerCase();
    return !name.includes('sms') && !name.includes('script bot');
}

export function getScriptBotLanguages(language) {
    return language.languageFullName.toLowerCase() === 'english script bot';
}

class SwitchLanguage {
    constructor(config) {
        const { options, context, $, room } = config;
        this.options = options;
        this.context = context;
        this.$ = $;
        this.nonSMSLanguages = [];
        this.scriptBotLanguage = [];
        this.multiLanguage_dropdown_wrapper = null;
        // this.room = room;
        this.languageBottomSheet = this.$(this.options.elements.language_bottomSheet, this.context);
        this.selectedLanguage = ApexChat.localStorageAPI.Get(
            TempCache.LIVE_THREE_LETTER_ISO_LANG
        );
    }

    renderMultiLanguageDropDown(config) {
        let supportedLanguages = this?.options?.model?.supportedLanguagesList || [];
        if (!supportedLanguages?.length) {
            supportedLanguages = this?.options?.supportedLanguagesList || []
        }
        if (supportedLanguages.length > 1) {
            this.nonSMSLanguages = supportedLanguages.filter(getNonSMSAndScriptLanguages);
            this.implementMultiLanguageSupport(config);
        } else if (supportedLanguages.length === 1) {
            this.scriptBotLanguage = supportedLanguages.filter(getScriptBotLanguages);
            this.implementMultiLanguageSupport(config);
        } else if (this.multiLanguage_dropdown_wrapper) {
            hideElement(this.multiLanguage_dropdown_wrapper[0]);
        }
    }

    requestTransferringChat(config) {
        const me = this;
        const chatId = getStorageAPIValue(TempCache.CHAT_ID_COOKIE) || 0;
        if (chatId > 0) {
            me.chatLanguageName = config && config.chatLanguageName ? config.chatLanguageName : me.chatLanguageName
            me.requestTransferringChatToOtherLanguage(chatId);
        }
    }

    requestTransferringChatToOtherLanguage(chatId) {
        const me = this;
        me.isOpen = true;
        const reqUrl = `${GlobalVariables.LiveChatServiceUrl}Services/ApexChatUtilityService.svc/chats/${chatId}/status`;
        me.requestAgentForTransferChat();
    }

    requestAgentForTransferChat() {
        const me = this;

        import(/* webpackChunkName: "liveChatRoom" */ '../LiveChatRoom').then((module) => {
            if (!me.room) {
                const LiveChatRoom = module.default;
                me.room = new LiveChatRoom(
                    Object.assign(me.options, {
                        isFromInvitation: true
                    })
                );
                me.room.initChatRoom();
                me.room.setChatId(
                    getCookieValue(TempCache.CHAT_ID_COOKIE),
                    getCookieValue(TempCache.CHAT_TOKEN_COOKIE)
                );
            }
            if (me.room) {
                languageTransferRequest(
                    GlobalVariables.LiveChatServiceUrl,
                    me.$.ajax,
                    me.options.chatModel.chatId,
                    me.chatLanguageName || me.options.language
                );
            }
        });
    }
    implementMultiLanguageSupport() {
        const languageBottomSheet = this.$(this.options.elements.language_bottomSheet, this.context);
        if (this.scriptBotLanguage?.length === 1) {
            this.$(this.options.elements.actionMenuLanguageSwitcher, this.context).hide();
            languageBottomSheet.hide();
            return;
        }
        if ((this.nonSMSLanguages.length <= 1) || (this.options.model?.scriptBotEnabled && !this.options.aiBotEnabled)) {
            const languageDropdown = this.$(this.options.elements.actionMenuLanguageSwitcher, this.context);
            if (languageDropdown) languageDropdown.remove();
            return;
        }

        const languageListContainer = languageBottomSheet.find(
            '.livechat_language_picker_list',
            this.context
        );

        this.chatLanguageInSession = TempStorageCache.get('apex_rd_chat_language');
        if (this.chatLanguageInSession) {
            TempCache.chatLanguage = this.chatLanguageInSession;
        }

        if (this.selectedLanguage) {
            TempCache.chatLanguage = this.selectedLanguage;
        }

        this.appendLanguagesToBottomSheet(languageListContainer);
    }

    appendLanguagesToBottomSheet(container) {
        const languageSendButton = this.context.querySelector('#livechat_language_picker_send');
        try {
            const template = languageTransferListTemplate({
                nonSMSLanguages: this.nonSMSLanguages,
                chatLanguage: TempCache.chatLanguage,
                isRDPlus: ApexChat.IsRoundedDynamicPlusTheme,
            });
            container.append(template);
        } catch (error) {
            console.error('error in languageTransferListTemplate', error);
        }

        this.selectLanguage(container, languageSendButton);
    }

    selectLanguage(container, trigger) {
        let selectedItem;
        let value;
        if (trigger) {
            trigger.style.display = 'none';
        }

        container.find('input', this.context).on('change', (event) => {
            value = event.target.value;
            selectedItem = this.nonSMSLanguages.find(
                (item) => item.threeLetterISOLanguageName === value
            );

            if (!selectedItem) return;

            this.threeLetterISOLanguageName = selectedItem.threeLetterISOLanguageName;
            this.chatLanguageName = selectedItem.languageFullName;

            if (trigger) {
                trigger.style.display = TempCache.chatLanguage !== value ? 'flex' : 'none';
            }
        });
        this.handleLanguageChangeRequest({ container, trigger, uicontroller: this });
    }

    handleLanguageChangeRequest(config) {
        const { trigger } = config;
        if (!trigger) return;
        trigger.addEventListener('click', this.submitRequest.bind(this));
        const languageBottomSheet = this.$(this.options.elements.language_bottomSheet, this.context);

        this.toggleLanguageBottomSheet(trigger, languageBottomSheet);
    }

    submitRequest() {
        TempStorageCache.add('apex_rd_chat_language', this.threeLetterISOLanguageName, true);

        if (
            !this.chatLanguageInSession ||
            TempCache.chatLanguage !== this.threeLetterISOLanguageName
        ) {
            this.requestTransferringChat();
        }

        TempCache.chatLanguage = this.threeLetterISOLanguageName;
        return this.threeLetterISOLanguageName;
    }
    toggleLanguageBottomSheet(el, bottomSheet) {
        if (!el) {
            return;
        }
        const me = this;

        "keyup click".split(" ").forEach(function (e) {
            el.addEventListener(e, (e) => {
                // check if button already not selected then do the action
                // e.stopPropagation();
                if (e.type == 'click' || (e.type == 'keyup' && isAcceptKey(e))) {
                    // check for mouse click or tab and enter key
                    // me.actionMenu.toggle()
                    const bottomSheetEl = me.languageBottomSheet || bottomSheet;
                    if (me.$(bottomSheetEl, me.context).is(":visible")) {
                        el.style.display = 'none'
                    }
                    me.$(bottomSheetEl, me.context).toggle();
                }
            });
        })
    }
}

export default SwitchLanguage;
